module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Category pa2-m pa4-l"
  }, [_c('header', {
    staticClass: "Category-Header"
  }, [_c('h2', {
    staticClass: "f4 f3-l"
  }, [_vm._v(_vm._s(_vm.model.name))]), _c('p', {
    staticClass: "f5 lh-copy measure gray",
    domProps: {
      "innerHTML": _vm._s(_vm.model.description)
    }
  })]), _c('div', {
    staticClass: "Category-Body"
  }, [_c(_vm.componentType, {
    tag: "component",
    attrs: {
      "selected-option-index": _vm.selectedOptionIndex
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-675f1059!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookartCategory/BookartCategory.vue
// module id = 191
// module chunks = 2